<template>
  <v-col class="px-5">
    <h2>{{ $translate('NOTIFICATIONS') }}</h2>
    <v-container v-if="hasSubscriptions" class="px-0" fluid>
      <v-card>
        <h3 class="pa-5">
          {{ getSubscriptionText() }}
        </h3>
        <v-card
          class="ma-2"
          elevation="1"
          v-for="(subs, index) in possibleSubscriptions"
          :key="index"
        >
          <v-card-text>
            <b>{{ subs.Name }}</b>
            <v-switch
              class="px-5"
              v-model="subs.MailSwitch"
              :label="$translate('SUBSCRIPTION_EMAILS')"
            />
            <v-switch
              class="px-5"
              v-model="subs.PushSwitch"
              :label="$translate('SUBSCRIPTION_PUSH')"
            />
          </v-card-text>
        </v-card>
        <v-card-actions>
          <v-alert text v-if="alert" :type="alertType">
            {{ alertText }}
          </v-alert>
          <v-spacer />
          <v-btn color="primary" @click="changeSubscriptions">
            <v-icon left>mdi-content-save</v-icon>
            {{ $translate('SAVE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-col>
</template>

<script>
import doRequest from '@/api/dssRequest';

export default {
  name: 'UserSettingsNotifications',
  data() {
    return {
      alert: false,
      alertType: 'success',
      alertText: '',
      possibleSubscriptions: [],
      notificationCheckbox: true,
    };
  },
  computed: {
    hasSubscriptions() {
      return (
        this.possibleSubscriptions != null &&
        this.possibleSubscriptions.length > 0
      );
    },
  },
  mounted() {
    this.checkUserSubscriptions();
  },
  methods: {
    getSubscriptionText() {
      let textForSubs = '';
      for (let i = 0; i < this.possibleSubscriptions.length; i++) {
        // check if it is the last subscription than don't use the space and comma
        if (i + 1 === this.possibleSubscriptions.length) {
          textForSubs += `'${this.possibleSubscriptions[i].Name}'`;
        } else {
          textForSubs += `'${this.possibleSubscriptions[i].Name}', `;
        }
      }
      return this.$translate('SUBSCRIPTION_TEXT').replace(
        '(recepten)',
        textForSubs
      );
    },
    checkUserSubscriptions() {
      const userSegments = [];
      this.$store.getters['auth/userSegments'].forEach((userSeg) => {
        userSeg.Segments.forEach((segment) => {
          userSegments.push(segment);
        });
      });
      this.possibleSubscriptions = [];

      userSegments.forEach((userSubs) => {
        if (userSubs.SubscribeByUser) {
          switch (userSubs.CommunicationState) {
            case -1:
              this.possibleSubscriptions.push({
                ...userSubs,
                MailSwitch: false,
                PushSwitch: false,
              });
              break;
            case 0:
              this.possibleSubscriptions.push({
                ...userSubs,
                MailSwitch: true,
                PushSwitch: true,
              });
              break;
            case 1:
              this.possibleSubscriptions.push({
                ...userSubs,
                MailSwitch: false,
                PushSwitch: true,
              });
              break;
            case 2:
              this.possibleSubscriptions.push({
                ...userSubs,
                MailSwitch: true,
                PushSwitch: false,
              });
              break;
          }
        }
      });
    },
    changeSubscriptions() {
      const payload = {
        Subscriptions: [],
      };
      this.possibleSubscriptions.forEach((subs) => {
        if (subs.MailSwitch && subs.PushSwitch) {
          subs.CommunicationState = 0;
          delete subs.MailSwitch;
          delete subs.PushSwitch;
        } else if (subs.MailSwitch && !subs.PushSwitch) {
          subs.CommunicationState = 2;
          delete subs.MailSwitch;
          delete subs.PushSwitch;
        } else if (!subs.MailSwitch && subs.PushSwitch) {
          subs.CommunicationState = 1;
          delete subs.MailSwitch;
          delete subs.PushSwitch;
        } else {
          subs.CommunicationState = -1;
          delete subs.MailSwitch;
          delete subs.PushSwitch;
        }
        payload.Subscriptions.push({
          CohortId: subs.CohortId,
          CommState: subs.CommunicationState,
        });
      });
      doRequest(
        (response) => {
          this.$store.commit('auth/setUserSegments', []);
          this.$store.commit(
            'auth/setUserSegments',
            response.data.SubScriptions
          );
          window.EventBus.fire('getUserData');
          this.checkUserSubscriptions();
          this.alertType = 'success';
          this.alertText = 'Youre changes has been saved';
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
            this.alertType = 'success';
            this.alertText = '';
          }, 3000);
        },
        () => {
          this.alertType = 'error';
          this.alertText =
            'Something went wrong while saving your subscriptions, please try again';
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
            this.alertType = 'success';
            this.alertText = '';
          }, 3000);
        },
        'changeSubscriptions',
        this.$store.getters['auth/userName'],
        payload
      );
    },
  },
};
</script>
